const doc = [({"en":({"js":({"users":({"confirmations":({"new":({"send_confirmation_email_again":"Send confirmation email again"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;